'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _klaviyoSubscribe = require('klaviyo-subscribe');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------------------------
Klayvio Email Signup
-------------------------------*/

function initEmailSubscribe() {
  var _this = this;

  // Get all of the forms on the page.
  var emailSignupForms = document.querySelectorAll('.email-signup');

  // Add submit listeners to each.
  [].concat((0, _toConsumableArray3.default)(emailSignupForms)).forEach(function (form) {
    form.addEventListener('submit', function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var response, email, listId;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                // Elements
                response = form.querySelector('.email-signup__response');

                // Form Details

                email = form.querySelector('input[name="email"]').value;
                listId = form.querySelector('input[name="g"]').value;

                // Subscribe

                _context.next = 6;
                return (0, _klaviyoSubscribe.subscribe)(listId, email);

              case 6:

                // Show Response
                response.style.display = 'block';
                response.innerText = 'Thank you for subscribing!';

                // Hide Response
                window.setTimeout(function () {
                  response.style.display = 'none';
                }, 3000);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
}

/*-------------------------------
Init
-------------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  initEmailSubscribe();
});

document.addEventListener('swup:contentReplaced', function (event) {
  initEmailSubscribe();
});